var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C17.066 0 22 4.93398 22 11C22 17.066 17.066 22 11 22C4.93398 22 0 17.066 0 11C0 4.93398 4.93398 0 11 0ZM11 1.53488C5.7635 1.53488 1.53488 5.76348 1.53488 11C1.53488 16.2365 5.7635 20.4651 11 20.4651C16.2365 20.4651 20.4651 16.2365 20.4651 11C20.4651 5.76348 16.2365 1.53488 11 1.53488ZM11 3.06977C11.4238 3.06977 11.7674 3.41338 11.7674 3.83721V11C11.7674 11.2119 11.6825 11.4047 11.5436 11.5436L6.84302 16.2442C6.54334 16.5439 6.05553 16.5439 5.75581 16.2442C5.45613 15.9445 5.45613 15.4567 5.75581 15.157L10.2326 10.6802V3.83721C10.2326 3.41338 10.5761 3.06977 11 3.06977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementClock);
export default __webpack_public_path__ + "static/media/element_clock.3eceb4f34bc1ec7d9fe73ee479afa43e.svg";
export { ForwardRef as ReactComponent };